import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isString } from 'lodash'

import { Text } from 'components/text/Text'

import styles from './ContentBlock.module.scss'

export const ContentBlock = ({ children, title, className }) => (
  <div className={classNames(styles.contentBlock, className)}>
    {isString(title) ? (
      <Text color="greyBlue" size={14} display="block">
        {title}
      </Text>
    ) : (
      title
    )}

    <div className={styles.body}>{children}</div>
  </div>
)

ContentBlock.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
